import {
  always,
  either,
  pipe,
  prop,
} from 'ramda'
import { useConnect } from 'redux-bundler-hook'

import createLogger from '~/src/Lib/Logging'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '~/src/Lib/Utils'

const logger = createLogger('Flags/Has#utils')

export const available = (availableFeatures = EMPTY_OBJECT, features = EMPTY_ARRAY, any = false) => {
  const requiredFeatures = Array.isArray(features) ? features : Array.of(features)
  logger.debug({ availableFeatures, requiredFeatures, any })
  return requiredFeatures[any ? 'some' : 'every'](flag => {
    const has = typeof flag === 'function' ? flag(availableFeatures) : availableFeatures.has(flag)

    return has
  })
}

const emptyAvailable = new Set()

export const useFlags = pipe(
  useConnect.bind(null, 'selectAvailableFeatures'),
  either(prop('availableFeatures'), always(emptyAvailable))
)

export const useHas = (features, any) => {
  const availableFeatures = useFlags()
  if (!features.length) return true
  return available(availableFeatures, features, any)
}
